import { Fragment } from 'react'
import Link from 'next/link'
import { StyledLink } from './Location.styles'
import { getLocationCopy } from 'utils/generalUtils'

type ListingLocation = {
  path: string
  name: string
}

type LocationProps = {
  breadcrumbs: Array<TODO>
  state: string
  city: string
}

const getDeepestPath = (breadcrumbs): string => {
  if (Array.isArray(breadcrumbs) && breadcrumbs.length > 0) {
    return breadcrumbs[breadcrumbs.length - 1]?.path
  }
}

const Location = ({ breadcrumbs, state, city }: LocationProps) => {
  const locationCopy = getLocationCopy(city, state)

  const location: ListingLocation = {
    path: getDeepestPath(breadcrumbs),
    name: locationCopy,
  }

  return (
    <Fragment>
      {breadcrumbs && location && (
        <Link href={location.path} passHref>
          <StyledLink>{location.name}</StyledLink>
        </Link>
      )}
    </Fragment>
  )
}

export default Location
